import React from 'react';

import {
  Box,
  Button,
  Chip,
  Stack,
  Typography,
} from '@mui/material';

import AddOutlinedIcon
  from '@mui/icons-material/AddOutlined';

import {
  GridColDef,
  GridRowId,
  GridValidRowModel,
} from '@mui/x-data-grid';

import FDataGrid from '../grid/FDataGrid';

import {
  TaskRow,
} from './activityplanning.models';


type Props = {
  rows: TaskRow[];
  selected: TaskRow | null;
  loading: boolean;
  canPlan: boolean;

  onSelect: (
    task: TaskRow | null
  ) => void;

  onAddToPlan: (
    task: TaskRow
  ) => void;

  onCreateNew: () => void;
};


export default class
  ActivityTaskRepositoryPanel
  extends React.Component<Props> {

  private columns = (): GridColDef[] => [
    {
      field: 'code',
      headerName: 'Task Code',
      width: 135,
    },
    {
      field: 'name',
      headerName: 'Task',
      minWidth: 180,
      flex: 1,
    },
    {
      field: 'planned',
      headerName: 'Plan',
      width: 100,

      renderCell: (params: any) => (
        <Chip
          size="small"
          variant="outlined"
          label={
            params.row.planned
              ? 'Planned'
              : 'Available'
          }
        />
      ),
    },
  ];

  private handleSelection = (
    row: GridValidRowModel | null,
    _rowId: GridRowId | null
  ) => {
    this.props.onSelect(
      row as TaskRow | null
    );
  };

  render() {
    const {
      rows,
      selected,
      loading,
      canPlan,
    } = this.props;

    return (
      <Box>
        <Typography
          variant="subtitle2"
          fontWeight={600}
        >
          Task Repository
        </Typography>

        <Typography
          variant="caption"
          color="text.secondary"
          display="block"
          sx={{ mb: 1 }}
        >
          Reusable Task definitions for this Activity.
          Review existing Tasks before creating a new one.
        </Typography>

        <FDataGrid
          rows={rows}
          columns={this.columns()}
          loading={loading}
          getRowId={(row: any) =>
            row.taskid ?? row.id
          }
          onSelectedRowChange={
            this.handleSelection
          }
        />

        <Stack
          direction="row"
          spacing={1}
          justifyContent="flex-end"
          sx={{ mt: 1 }}
        >
          {selected &&
            !selected.planned && (
              <Button
                size="small"
                disabled={!canPlan}
                onClick={() =>
                  this.props.onAddToPlan(
                    selected
                  )
                }
              >
                Add to Plan
              </Button>
            )}

          <Button
            size="small"
            startIcon={
              <AddOutlinedIcon />
            }
            disabled={!canPlan}
            onClick={
              this.props.onCreateNew
            }
          >
            Create New Task
          </Button>
        </Stack>
      </Box>
    );
  }
}